import { combineReducers } from 'redux';

import IdCards from './idcards/reducer';

export default combineReducers({
  IdCards,
});



// WEBPACK FOOTER //
// ./src/pages/idcards/state/reducer.js